import { IUserViewModel } from "../../model/respone/user/IUserViewModel";
import { apiClient } from "../apiClient";
export const USER_API_RESOURCE = 'user';
export const USER_API_DELETE_RESOURCE = `${USER_API_RESOURCE}/{id}`;
export const userApi = {
    selectAll: () => apiClient.get(USER_API_RESOURCE),
    detail: (id: number) => apiClient.get(`${USER_API_RESOURCE}/${id}`),
    insert: (user: IUserViewModel) => apiClient.post(USER_API_RESOURCE, user),
    update: (user: IUserViewModel) => apiClient.put(USER_API_RESOURCE, user),
    delete: (id: number) => apiClient.delete(`${USER_API_RESOURCE}/${id}`),
    resetPW: (payload: any) => apiClient.put(`${USER_API_RESOURCE}/reset-pw`,payload),
    userChangePassword: (payload: any) => apiClient.put(`account/change-password`,payload),
}